export enum McaCurrentSpectrumPlotLineTypeEnum {
  HARMONIC = "Harmonic",
  SIDEBAND = "Sideband",
}
